import React from "react";
import Context from "../../../Context";
import EssenceActionsDropdown from "../../Essence/EssenceActionsDropdown";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";
import Blocker from "../../Misc/Blocker";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import SuperSelect from "../../Misc/SuperSelect";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import EssenceReferenceStorageEdit from "../../Essence/EssenceReferenceStorageEdit";
import FormLine from "../../Misc/FormLine";
import DocumentPicker from "../../Misc/DocumentPicker";
import EssenceFiles from "../../Essence/EssenceFiles";
import { Link } from "react-router-dom";
import TypeChanger from "../../Misc/TypeChanger";
import ModelPicker from "../../Misc/ModelPicker";
import Datetime from "react-datetime";
import DtPicker from "../../Misc/DtPicker";
import OutsideInput from "../../Misc/Outside/OutsideInput";
import ElasticInput from "../../Misc/ElasticInput";
import ObjectLink from "../../Misc/ObjectLink";

export default class Request extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      item: {},
      lines: [],
      models: {},
      measure: [],
      currency: [],

      modelPickShow: false,
      modelPickIdx: false,
      modelPickKey: "",

      mode: "default",
    };
  }

  componentDidMount() {
    this.loadReferences().then(() => this.load());
    this.renderButtons();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.requestId !== this.props.requestId) {
      this.load();
    }
    this.renderButtons();
  }

  onChange = (id, value) => {
    this.setState((state) => {
      let { item } = state;
      item[id] = value;
      return { item };
    });
  };

  onLineChange = (idx, key, value) => {
    let { lines } = this.state;
    lines[idx][key] = value;
    this.setState({ lines });
  };

  getModelLabel = (id, defaultLabel = "") => {
    let result = defaultLabel;
    if (this.state.models[id]) {
      result = `${this.state.models[id].label}`;
    }
    return result || "";
  };

  getModelCode = (id, defaultCode = "") => {
    let result = defaultCode;
    if (this.state.models[id]) {
      result = this.state.models[id].subcode;
    }
    return result || "";
  };

  onCreateModel = async (model) => {
    this.setState(
      (state) => {
        let { models } = state;
        models[model.id] = { label: model.label };
        return { models };
      },
      () => this.onLineChange(this.state.modelPickIdx, "modelid", model.id)
    );
  };

  onModelPickOpen = (idx) => {
    this.setState({ modelPickShow: true, modelPickIdx: idx });
  };

  onModelPickClose = () => {
    this.setState({ modelPickShow: false });
  };

  onModelPick = (model) => {
    this.setState(
      ({ models }) => {
        models[model.id] = model;
        return models;
      },
      () => this.onLineChange(this.state.modelPickIdx, "modelid", model.id)
    );
  };

  onModelSubcodeChange = async (idx, v) => {
    let line = this.state.lines[idx] || {};
    let model = this.state.models[line.modelid] || line.model;
    if (!model) return;

    let label = this.getModelLabel(line.modelid, line?.model?.name);

    let promptResult = await this.context.ask(
      `Изменить специальный код ${label} на ${v}?`
    );
    if (promptResult.value) {
      let saveData = {
        id: line.modelid,
        subcode: v,
      };
      this.setState({ pending: true });
      let result = await this.context.api.q(`/model/set`, saveData);
      this.setState({ pending: false });
      if (result) {
        this.setState((state) => {
          let { models } = state;
          models[line.modelid] = {
            ...model,
            subcode: v,
            label: model.label || model.name,
          };
          return { models, modelPickKey: this.context.key() };
        });
      } else {
        this.context.toast("Не удалось изменить запись", "error");
      }
    }
  };

  loadReferences = async () => {
    this.setState({ pending: true });
    let models = {};
    let measure = await this.context.api.qrc("/measure/list");
    this.setState({ pending: false, models, measure });
  };

  rowAdd = (idx) => {
    let { lines } = this.state;
    let index = idx || lines.length;
    lines.splice(index, 0, {});
    this.setState({ lines });
  };

  rowRemove = (idx) => {
    let { lines } = this.state;
    lines.splice(idx, 1);
    this.setState({ lines });
  };

  load = async () => {
    const { requestId } = this.props;
    this.setState({ pending: true, notFound: false });
    if (requestId && requestId !== "add") {
      let item = await this.context.api.q("/request/get", { id: requestId });
      if (!item) {
        this.setState({ notFound: true });
      } else {
        let lines = await this.context.api.qa("/request/item/list", {
          filter: { documentid: requestId },
          orderby: ["itemid ASC"],
        });

        this.setState({ item, lines: lines || [] });
      }
    } else {
      await this.loadAppended();
      this.setState({ item: {} });
    }
    this.setState({ pending: false, mode: "default" });
    this.context.force();
  };

  loadAppended = async () => {
    let searchParams = new URLSearchParams(
      this.props.location.search.substr(1)
    );
    let append = searchParams.get("append");
    if (append) {
      let appendItems = append.split(",");
      await this.loadNeededModels(appendItems);
      this.setState({
        lines: appendItems.map((modelid) => {
          return { modelid };
        }),
      });
    }
  };

  loadNeededModels = async (id = []) => {
    if (!id?.length) return;
    let appendQuery = await this.context.api.qo("/model/list", {
      fields: ["id", "label", "code", "subcode"],
      search: [{ field: "id", valarr: id }],
    });
    this.setState(({ models }) => {
      return { models: Object.assign(models, appendQuery) };
    });
  };

  save = async () => {
    let requestId = null;
    if (this.props.requestId && this.props.requestId !== "add") {
      requestId = this.props.requestId;
    }

    const { item } = this.state;
    this.setState({ pending: true });
    let saveData = {
      id: requestId,
      storage: item.storage,
      description: item.description,
      parent: item.parent,
      type: item.type,
      priority: item.priority,
      rationale: item.rationale,
    };
    let result = await this.context.api.q("/request/set", saveData);

    if (result !== false) {
      let items = [];
      let { lines } = this.state;
      lines.forEach((line) => {
        items.push({
          modelid: line.modelid,
          measureid: line.measureid,
          deliverydate: line.deliverydate,
          volume: line.volume,
        });
      });

      let itemsResult = await this.context.api.q("/request/item", {
        items,
        document: result.id,
      });
      if (itemsResult !== false) {
        this.context.toast("Изменения сохранены", "success");
      } else {
        this.context.toast("Не удалось сохранить изменения", "error");
      }
      this.setState({ pending: false });

      if (this.props.requestId === "add") {
        this.context.redirect(`/request/${result.id}`);
      } else {
        if (itemsResult !== false) {
          this.load();
        }
      }
    } else {
      this.setState({ pending: false });
      this.context.toast("Не удалось сохранить изменения", "error");
    }
  };

  new = () => {
    this.setState({ lines: [] });
    this.context.redirect("/request/add");
  };

  open = () => {
    const { requestId } = this.props;
    if (requestId && requestId !== "add") {
      this.context.redirect(`/workdoc/any/any/${requestId}`);
    } else {
      this.context.redirect("/workdoc/");
    }
  };

  renderButtons = () => {
    this.context.actionsSet(
      <>
        <button
          title="Новый"
          onClick={this.new}
          className={`btn btn-icon btn-light mr-2`}
        >
          <i className="fa fa-file-o"></i>
        </button>
        <button
          title="Сохранить"
          onClick={this.save}
          className={`btn btn-icon btn-light mr-2`}
        >
          <i className="fa fa-save"></i>
        </button>
        <button
          title="Открыть"
          onClick={this.open}
          className={`btn btn-icon btn-light mr-2`}
        >
          <i className="fa fa-folder-open-o"></i>
        </button>
      </>
    );
  };

  onModeChange = (mode) => {
    this.setState({ mode });
  };

  render() {
    const { item, notFound, pending, lines } = this.state;
    const { requestId } = this.props;
    let title = requestId === "add" ? "Новая заявка" : item.label;

    if (notFound) {
      title = "Документ не найден";
      return (
        <div className="container">
          <CrumbsProvider title={title} />
          <DefaultNotFound />
        </div>
      );
    }

    return (
      <>
        <ModelPicker
          listKey={this.state.modelPickKey}
          onModelPick={this.onModelPick}
          onClose={this.onModelPickClose}
          onCreate={this.onCreateModel}
          show={this.state.modelPickShow}
          allowCreate
          keepModal
        />

        <CrumbsProvider title={title} link={`/request/${item.id}/`} />
        <div className="container h-100">
          <div className="row  h-100">
            <div className="col">
              <Blocker on={pending}>
                <div className="card card-custom card-stretch">
                  <div className="card-body px-5 py-5">
                    <div className="dochat">
                      <div className="flex-grow-1">
                        <div className="row">
                          <TypeChanger
                            defaultValue={item.type}
                            classCode={"request"}
                            onChange={(value) => this.onChange("type", value)}
                            wrap={(children) => (
                              <div className="col-12 mb-4">
                                <FormLine label="Тип:">{children}</FormLine>
                              </div>
                            )}
                          />

                          <div className="col">
                            <FormLine label="Основание:">
                              <DocumentPicker
                                classes={[
                                  "workdoc",
                                  "fda",
                                  "troubleshooting",
                                  "cancellation",
                                ]}
                                states={["disabled"]}
                                defaultValue={item.parent}
                                onChange={(value) =>
                                  this.onChange("parent", value)
                                }
                              />
                            </FormLine>
                          </div>
                          <div className="col">
                            <FormLine label="Приоритет:">
                              <SuperSelect
                                cache
                                forcePath="/priority"
                                defaultValue={item.priority}
                                onChange={(value) =>
                                  this.onChange("priority", value)
                                }
                                essence="priority"
                                nameField="name"
                                idField="id"
                              />
                            </FormLine>
                          </div>

                          <div className="col-12 mt-4">
                            <FormLine label="Обоснование:">
                              <ElasticInput
                                rows={1}
                                value={item.rationale || ""}
                                onChange={(e) =>
                                  this.onChange("rationale", e.target.value)
                                }
                                className="form-control"
                              />
                            </FormLine>
                          </div>

                          <div className="col-12 mt-4">
                            <FormLine label="Комментарий:">
                              <ElasticInput
                                rows={1}
                                value={item.description || ""}
                                onChange={(e) =>
                                  this.onChange("description", e.target.value)
                                }
                                className="form-control"
                              />
                            </FormLine>
                          </div>
                        </div>
                      </div>

                      {item.id && (
                        <div className="d-flex align-items-center ml-3">
                          <EssenceStateLabel
                            onAfterStateChanged={(c) => {
                              if (c === "enabled") {
                                this.open();
                              }
                            }}
                            id={item.id}
                            stateCode={item.statetypecode}
                            stateLabel={item.statelabel}
                            essence="request"
                          />
                          <EssenceActionsDropdown
                            essence={"request"}
                            key={item.id}
                            id={item.id}
                            label={item.label}
                            onFinish={this.load}
                          />
                        </div>
                      )}
                    </div>

                    <ul className="nav nav-tabs mb-4">
                      <li className="nav-item w-lg-auto w-100">
                        <div
                          onClick={() => this.onModeChange("default")}
                          className={` ${
                            this.state.mode === "default" ? "active" : ""
                          } cursor-pointer nav-link`}
                        >
                          Заявка
                        </div>
                      </li>
                      <li className="nav-item w-lg-auto w-100">
                        <div
                          onClick={() => this.onModeChange("files")}
                          className={` ${
                            this.state.mode === "files" ? "active" : ""
                          } cursor-pointer nav-link`}
                        >
                          Файлы
                        </div>
                      </li>
                      <li className="nav-item w-lg-auto w-100">
                        <div
                          onClick={() => this.onModeChange("documents")}
                          className={` ${
                            this.state.mode === "documents" ? "active" : ""
                          } cursor-pointer nav-link`}
                        >
                          Документы
                        </div>
                      </li>
                    </ul>
                    {this.state.mode === "default" && (
                      <table className="table">
                        <thead>
                          <tr>
                            <th>
                              <i
                                title="Добавить строку"
                                onClick={() => this.rowAdd()}
                                className="fa fa-plus cursor-pointer text-hover-primary mr-2"
                              ></i>
                              Наименование
                            </th>
                            <th width="15%">Спец.код</th>
                            <th width="12%">Желаемый срок</th>
                            <th width="15%">Кол-во</th>
                            <th width="15%">Eд. изм.</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lines.map((item, idx) => {
                            let line = item || {};
                            return (
                              <tr key={idx}>
                                <td>
                                  <div className="input-group">
                                    <input
                                      readOnly
                                      type="text"
                                      className="form-control"
                                      placeholder="ЗИП"
                                      value={this.getModelLabel(
                                        line.modelid,
                                        line?.model?.name
                                      )}
                                      onDoubleClick={() =>
                                        this.onModelPickOpen(idx)
                                      }
                                    />
                                    <div className="input-group-append">
                                      <button
                                        title="Выбрать"
                                        className="btn btn-icon border"
                                        type="button"
                                        onClick={() =>
                                          this.onModelPickOpen(idx)
                                        }
                                      >
                                        <i className="fa icon-md text-muted fa-navicon"></i>
                                      </button>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div className="input-group">
                                    <OutsideInput
                                      uncontrolled
                                      pickField="code"
                                      source="model.subcode"
                                      value={
                                        this.getModelCode(
                                          line.modelid,
                                          line?.model?.subcode
                                        ) || ""
                                      }
                                      onChange={(v) =>
                                        this.onModelSubcodeChange(idx, v)
                                      }
                                    />
                                  </div>
                                </td>
                                <td>
                                  <DtPicker
                                    isClearable
                                    onChange={(v) =>
                                      this.onLineChange(idx, "deliverydate", v)
                                    }
                                    value={item.deliverydate}
                                  />
                                </td>
                                <td>
                                  <input
                                    className="form-control"
                                    value={item.volume || ""}
                                    size={3}
                                    type="number"
                                    onChange={(e) =>
                                      this.onLineChange(
                                        idx,
                                        "volume",
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>

                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                      <Select
                                        value={this.context.api.getReferenceValue(
                                          line.measureid,
                                          this.state.measure
                                        )}
                                        onChange={(result) =>
                                          this.onLineChange(
                                            idx,
                                            "measureid",
                                            result.value
                                          )
                                        }
                                        className="from-control react-select"
                                        classNamePrefix="react-select-inner"
                                        options={this.state.measure}
                                        placeholder="..."
                                        noOptionsMessage={({ inputValue }) =>
                                          `Ничего не найдено по запросу ${inputValue}`
                                        }
                                      />
                                    </div>
                                    <div className="ml-3 text-nowrap">
                                      <i
                                        title="Удалить строку"
                                        onClick={() => this.rowRemove(idx)}
                                        className="fa fa-times cursor-pointer text-hover-danger "
                                      ></i>
                                      <i
                                        title="Добавить строку ниже"
                                        onClick={() => this.rowAdd(idx + 1)}
                                        className="fa fa-plus cursor-pointer text-hover-primary ml-2"
                                      ></i>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    )}
                    {this.state.mode === "files" && (
                      <div>
                        {this.state.item.id && (
                          <EssenceFiles
                            essence="request"
                            id={this.state.item.id}
                            key={this.state.item.id}
                          />
                        )}
                        {!this.state.item.id && (
                          <div className="alert alert-light">
                            Чтобы прикрепить файлы сначала сохраните документ
                          </div>
                        )}
                      </div>
                    )}
                    {this.state.mode === "documents" && (
                      <div>
                        {this.state.item.id && (
                          <ObjectLink canManage id={this.state.item.id} />
                        )}
                        {!this.state.item.id && (
                          <div className="alert alert-light">
                            Чтобы привязать другие документы сначала сохраните
                            этот документ
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </Blocker>
            </div>
          </div>
        </div>
      </>
    );
  }
}
